import { render, staticRenderFns } from "./TranferOrgSecond.vue?vue&type=template&id=5d8daa5f&scoped=true"
import script from "./TranferOrgSecond.vue?vue&type=script&lang=js"
export * from "./TranferOrgSecond.vue?vue&type=script&lang=js"
import style0 from "./TranferOrgSecond.vue?vue&type=style&index=0&id=5d8daa5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8daa5f",
  null
  
)

export default component.exports